import Vue from "vue";
import day from 'dayjs' // load on demand
import 'dayjs/locale/pt-br' // load on demand

var weekOfYear = require('dayjs/plugin/weekOfYear')
day.extend(weekOfYear)

var isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
day.extend(isSameOrBefore)

day.locale('pt-br') // use PTBR locale globally

// Vue.use(day);

Vue.prototype.$dayjs = day;
